
const state = {
  brand_group_id: undefined,
  id: null,
  identity_code: '',
  provider_id: undefined,
}

export const requiredFields = [
  { key: 'brand_group_id' },
  { key: 'provider_id' },
]

export default state
